export default "<p>edit-product-quote-modal works!</p>\r\n"